// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3OLlk","imageUploader":"EGiftCard_imageUploader__3YxOv"};